import React, { useEffect } from "react";
import { DateTime } from "luxon";
// import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { getBidderOnboardingOfUser, getUser } from "services";
import {
  clearAuth,
  clearBidderAuth,
  clearGuestUser,
  setBidderOnboarding,
  setBidderUser,
  setOnboarding,
  setTokens,
  setUser,
} from "store";
import useToken from "app/hoc/bidder/useToken";

export default function UserAttributeWrapper(props: any) {
  const dispatch = useDispatch();
  const { token } = useToken();

  useEffect(() => {
    (async () => {
      if (token?.login_date) {
        const todayIST = DateTime.now().setZone("Asia/Kolkata");
        const loginDate = DateTime.fromFormat(token?.login_date, "yyyy-MM-dd", {
          zone: "Asia/Kolkata",
        });
        const daysPassed = todayIST.diff(loginDate, "days").days;
        console.log("login days passed: ", daysPassed);
        if (daysPassed > 30) {
          console.log("Session expired (30+ days). Logging out...");
          dispatch(clearAuth());
          dispatch(clearGuestUser());
          dispatch(clearBidderAuth());
          return;
        }
      }

      if (token && token.isLoggedIn) {
        dispatch(setTokens(token));
        await new Promise((resolve) => setTimeout(resolve, 250));
        const userData: any = await getUser();
        dispatch(setUser(userData));
        dispatch(setBidderUser(userData));
        const onboardingData: any = await getBidderOnboardingOfUser(
          userData?.uuid
        );
        dispatch(setOnboarding(onboardingData));
        dispatch(setBidderOnboarding(onboardingData));
      }
      if (token && !token.isLoggedIn) {
        dispatch(clearAuth());
        // dispatch(clearGuestUser());
        dispatch(clearBidderAuth());
      }
    })();
  }, [token?.isLoggedIn]);
  return props.children;
}
